<template>
    <div class="login">
        <div class="fd-list-header">
            <h1 class="fd-list-header__brand">Redhill Food Distribution</h1>
        </div>

        <div class="card">
            <div class="card-content">
                <h1 class="title is-6 has-text-centered">Login</h1>
                <div v-if="counter < 4" class="block">
                    <div class="field">
                        <p class="control has-icons-left">
                            <input v-model="email" class="input" type="email" inputmode="email" @change="resetError"
                                placeholder="Email">
                            <span class="icon is-small is-left">
                                <i class="fas fa-envelope"></i>
                            </span>
                        </p>
                    </div>
                    <div class="field">
                        <p class="control has-icons-left">
                            <input v-model="password" class="input" type="password" @change="resetError" placeholder="Password">
                            <span class="icon is-small is-left">
                                <i class="fas fa-lock"></i>
                            </span>
                        </p>
                    </div>
                    <div class="field">
                        <p class="control">
                            <button :disabled="!email || !password" class="button is-primary is-fullwidth is-medium"
                                :class="[isLoading ? 'is-loading' : '']" @click="login">
                                <span class="icon">
                                    <i class="fas fa-sign-in-alt"></i>
                                </span>
                                <span>Login</span>
                            </button>
                        </p>
                    </div>
                    <div class="field">
                        <p class="control">
                            <button class="button is-white is-fullwidth is-medium" style="border: 1px solid #ddd"
                                :class="[isGoogleLoading ? 'is-loading' : '']" @click="loginWithGoogle">
                                <span class="icon">
                                    <i class="fab fa-google"></i>
                                </span>
                                <span>Continue with Google</span>
                            </button>
                        </p>
                    </div>
                    <div class="field">
                        <div class="control">
                            <ResetPassword :email="this.email"></ResetPassword>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="validationErrors.length" class="block notification is-danger is-light">
            <p>
                <b>Please correct the following error(s):</b>
            <ul>
                <li v-for="validationError in validationErrors" :key="validationError">{{ validationError }}</li>
            </ul>
            </p>
        </div>

        <div class="block">
            <div v-if="!!error" class="notification is-danger is-light">
                <p v-if="counter <= 3">{{ error }} <span v-if="counter > 1">({{ counter }})</span></p>
                <p v-else>You have reached maximum number of login attempts. Please contact the administrator.</p>
            </div>
        </div>
        

        <div class="block notification">
            <h1 class="title is-6">Don't have an account?</h1>
            <router-link to="/register">
                <button class="button is-rounded is-success is-medium">Register as a Volunteer</button>
            </router-link>
        </div>

        <div class="block has-text-centered">
            <router-link to="/volunteer" class="has-text-grey is-size-7">
                Check volunteering opportunities →
            </router-link>
        </div>

       
    </div>
</template>


<script>
import ResetPassword from "@/components/user/ResetPassword.vue";

export default {
    components: {
        ResetPassword
    },
    data() {
        return {
            isLoading: false,
            isGoogleLoading: false,
            error: null,
            email: "",
            password: "",
            counter: 0,
            isFormValid: true,
            validationErrors: []
        }
    },
    watch: {
        email() {
            this.email = this.email.toLowerCase()
        }
    },
    methods: {
        async login() {
            this.isLoading = true;
            this.validateForm();
            if (this.isFormValid) {
                try {
                    await this.$store.dispatch('user/login', {
                        email: this.email,
                        password: this.password
                    });
                } catch (error) {
                    this.error = error.message;
                    this.counter++;
                }
            }
            this.isLoading = false;
        },
        async loginWithGoogle() {
            this.isGoogleLoading = true;
            try {
                await this.$store.dispatch('user/loginWithGoogle');
            } catch (error) {
                this.error = error.message || 'Google sign-in failed.';
            }
            this.isGoogleLoading = false;
        },
        resetError() {
            this.error = null;
        },
        validateForm() {
            this.isFormValid = false;
            this.validationErrors = [];
            if (!this.email) {
                this.validationErrors.push("Email required.");
            } else {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(this.email)) {
                    this.validationErrors.push("Email is not valid.");
                }
            }
            if (!this.password) {
                this.validationErrors.push("Password required.");
            } else {
                if (this.password.length < 6) {
                    this.validationErrors.push("Password must be at least 6 chars.");
                }
            }
            if (!this.validationErrors.length) {
                this.isFormValid = true;
            }
        }
    }
}

</script>
    
<style scoped>
.login {
    text-align: center;
    max-width: 400px;
    padding: 20px;
    margin: 0 auto;
}

.fd-list-header {
    text-align: center;
    padding: 1.25rem 0 0.5rem;
}

.fd-list-header__brand {
    font-size: 1.6rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.5px;
}

.card {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-radius: 8px;
    border: none;
}
</style>
    